import React, { useEffect, useRef } from 'react';

interface LegalContentFrameProps {
  html: string;
  title: string;
}

/** Renders a self-contained HTML document inside an isolated iframe. */
export default function LegalContentFrame({ html, title }: LegalContentFrameProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write(html);
      doc.close();
    }
  }, [html]);

  return (
    <iframe
      ref={iframeRef}
      title={title}
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
}
